import {addAuthKey} from "@/helpers/addAuthKeyToUrl";

const api_url = "/index.php";

export default {
    namespaced: true,

    state: {
        sidebarCollapsed: false,

        isAccessIikoCustomersControl: document.body.dataset.isAccessIikoCustomersControl,

        menuItems: {
            calculations: [
                { label: "Расчеты", route: "calculations" },
                { label: "Новый расчет", route: "calculation" },
                { label: "Монитор", route: null },
                { label: "Заказы", route: null },
                { label: "Длинные маршруты", route: null },
                { label: "Заказы на карте", route: null },
                { label: "Маршруты водителей", route: null },
                { label: "Мастер настроек", route: null }
            ],
            reports: [
                { label: "OLAP-отчет «Расчеты»", route: "olap-report-calculations" },
                { label: "Время работы офисных сотрудников", route: null },
                { label: "Сводный отчет", route: null },
                { label: "Доставка сводный", route: null },
                { label: "Опоздания сводный", route: null },
                { label: "Оплата труда", route: null },
                { label: "Доставка по сотрудникам", route: null },
                { label: "КОРФ / Нагрузка / Опоздания по должностям", route: null },
                { label: "Сводный - таблица", route: null },
                { label: "Опоздания", route: null },
                { label: "Депозиты", route: null },
                { label: "Рекомендации по смене разрядов", route: null },
                { label: "Штрафы и премии", route: null },
                { label: "KPI и отзывы водителей", route: null },
                { label: "Водители, не добравшиеся до минималки", route: null },
                { label: "Внешние заказы", route: null },
                { label: "Сводный по нарушениям", route: null },
                { label: "Отчет о проблемных местах в работе сайта / iiko", route: null },
                { label: "Отчет по блюдам без категорий", route: null },
                { label: "OLAP по расчетам", route: null },
                { label: "OLAP по сотрудникам", route: null },
                { label: "Power BI", route: null },
                { label: "Отчет по выручке", route: null },
                { label: "Время работы офисных сотрудников", route: null },
                { label: "Сводный отчет", route: null },
                { label: "Доставка сводный", route: null },
                { label: "Опоздания сводный", route: null },
                { label: "Оплата труда", route: null },
                { label: "Доставка по сотрудникам", route: null },
                { label: "КОРФ / Нагрузка / Опоздания по должностям", route: null },
                { label: "Сводный - таблица", route: null },
                { label: "Опоздания", route: null },
                { label: "Депозиты", route: null },
                { label: "Рекомендации по смене разрядов", route: null },
                { label: "Штрафы и премии", route: null },
                { label: "KPI и отзывы водителей", route: null },
                { label: "Водители, не добравшиеся до минималки", route: null },
                { label: "Внешние заказы", route: null },
                { label: "Сводный по нарушениям", route: null },
                { label: "Отчет о проблемных местах в работе сайта / iiko", route: null },
                { label: "Отчет по блюдам без категорий", route: null },
                { label: "OLAP по расчетам", route: null },
                { label: "OLAP по сотрудникам", route: null },
                { label: "Power BI", route: null },
                { label: "Отчет по выручке", route: null },
                { label: "Отчет по остатку задолженности", route: null },
            ],
            employees: [
                { label: "Сотрудники", route: "employees-list" },
                { label: "Штатная численность", route: null },
                { label: "Потребность в персонале", route: null },
                { label: "Кандидаты", route: null },
                { label: "Жалобы и предложения", route: null },
                { label: "Приказы/Инструкции", route: null },
                { label: "Анкеты водителей", route: null },
                { label: "Праздничные надбавки", route: null },
                { label: "Надбавки за лучшие показатели", route: null },
                { label: "Печать договоров", route: null },
                { label: "Управление уведомлениями", route: null },
            ],
            marketing: [
                { label: "Маркетинг", route: null },
                { label: "Акции", route: null },
            ],
            references: [
                { label: "Должности и разряды", route: "positions" },
                { label: "Клиенты", route: "reference-clients", access: "iikoCustomersControl" },
            ],
            bookmarks: [],
        },

        notificationsInfo: {
            notificationsList: [],
            notificationsCount: 0,
        }
    },

    getters: {
        sidebarCollapsed: (state) => state.sidebarCollapsed,

        menuItems: (state, getters, rootState) => {
            Object.entries(state.menuItems).forEach(([menuGroup, menuItems]) => {
                menuItems.forEach((menuItem, menuItemIndex) => {
                    if (menuItem.access === "iikoCustomersControl" && !rootState.isAccessIikoCustomersControl) {
                        state.menuItems[menuGroup].splice(menuItemIndex, 1);
                    }
                });
            });
            return state.menuItems;
        },

        getNotificationsInfo (state) {
            return state.notificationsInfo;
        }
    },

    mutations: {
        setSidebarCollapsed (state, value) {
            state.sidebarCollapsed = value;
        },
        setNotificationsInfo (state, value) {
            state.notificationsInfo.notificationsList = value.notifications;
            state.notificationsInfo.notificationsCount = value.notifications_count;
        }
    },

    actions: {
        async getMenuList(ctx) {
            const token = ctx.rootState.authToken;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/menu/list`, token));
            const json = await res.json();
            
            return json;
        },

        async getUserNotificationsList(ctx) {
            const token = ctx.rootState.authToken;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/menu/notifications`, token));
            const json = await res.json();

            ctx.commit("setNotificationsInfo", json.response);

            return json;
        }
    }
};
